import { isDate, parseISO } from 'date-fns';

class TypeService {
  public static isBoolean(value: unknown) {
    return typeof value === 'boolean' || value instanceof Boolean;
  }

  public static isNumber(value: any): boolean {
    return !isNaN(value) && value !== null && value !== '' && isFinite(Number(value));
  }

  public static isString(value) {
    return typeof value === 'string' || value instanceof String;
  }

  public static isEqual(value1: any, value2: any): boolean {
    if (value1 === value2) {
      return true;
    }

    if (value1 == null || value2 == null) {
      return false;
    }

    if (typeof value1 === 'object' && typeof value2 === 'object') {
      if (Array.isArray(value1) && Array.isArray(value2)) {
        if (value1.length !== value2.length) {
          return false;
        }

        for (let i = 0; i < value1.length; i++) {
          if (!TypeService.isEqual(value1[i], value2[i])) {
            return false;
          }
        }
        return true;
      }

      if (!Array.isArray(value1) && !Array.isArray(value2)) {
        const keys1 = Object.keys(value1);
        const keys2 = Object.keys(value2);

        if (keys1.length !== keys2.length) {
          return false;
        }

        for (const key of keys1) {
          if (!keys2.includes(key) || !TypeService.isEqual(value1[key], value2[key])) {
            return false;
          }
        }

        return true;
      }
    }

    return false;
  }

  public static isValidISODateString(value: unknown): value is string {
    if (typeof value !== 'string') return false;

    const isoRegex = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|([+-]\d{2}:\d{2}))?)?$/;
    if (!isoRegex.test(value)) return false;

    try {
      const parsed = parseISO(value);
      return isDate(parsed) && !isNaN(parsed.getTime());
    } catch {
      return false;
    }
  }

  public static ensureArray<T>(value: T | T[] | null | undefined): T[] {
    return Array.isArray(value) ? value : value ? [value] : [];
  }
}

export default TypeService;
